import { render, staticRenderFns } from "./PowerSlider.vue?vue&type=template&id=e15f99fa&"
import script from "./PowerSlider.vue?vue&type=script&lang=ts&"
export * from "./PowerSlider.vue?vue&type=script&lang=ts&"
import style0 from "./PowerSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports